'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

var fontFamily = _styles.typography.fontStack.fontFamily;
var color = _styles.colors.baseColors.charcoalGrey;

exports.default = function (small) {
	return {
		fontFamily: fontFamily,
		color: color,
		fontSize: small ? _styles.typography.small.fontSize : _styles.typography.body.fontSize,
		lineHeight: small ? _styles.typography.small.lineHeight : _styles.typography.body.lineHeight
	};
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMText/styles/index.js